import { useEffect, useState } from "react";
import { getConsumer, getSubscription } from "../../actionCableConsumerPool";

/**
 * Subscribes to real-time filter change notifications for a report.
 * Returns whether the stale filters modal should be shown, and a setter to control it.
 */
export function useStaleFilters(reportId?: number) {
  const [showStaleFiltersModal, setShowStaleFiltersModal] = useState(false);

  useEffect(() => {
    if (!reportId) return;

    const consumer = getConsumer();
    const subscription = getSubscription(
      consumer,
      "ReportFiltersChannel",
      { report_id: reportId },
      {
        received(data: { type: string }) {
          if (data.type === "filters_changed") {
            setShowStaleFiltersModal(true);
          }
        },
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [reportId]);

  return { showStaleFiltersModal, setShowStaleFiltersModal };
}
